module.exports = __webpack_public_path__ + "img/book_otros.5b6901e3.jpg";